import React, { useState } from 'react'
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/thumbs/thumbs.min.css'

import './styles.scss'

// import Swiper core and required modules
import SwiperCore, { Navigation, Thumbs } from 'swiper/core'
import { Property } from 'generated/graphql'
import {
  Center,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Skeleton,
  useMediaQuery
} from '@chakra-ui/react'
import { images } from 'theme'

// install Swiper modules
SwiperCore.use([Navigation, Thumbs])
type SlideShowModalProps = {
  property: Property
  loading?: boolean
  isOpen: boolean
  initialSlide?: number
  onClose: () => void
}

const SlideShowModal: React.FC<SlideShowModalProps> = ({
  property,
  loading,
  isOpen,
  onClose,
  initialSlide
}) => {
  const [thumbsSwiper] = useState<SwiperCore | null | undefined>(null)
  const [isMobileOrTablet] = useMediaQuery('(max-width: 40em)')
  return (
    <Modal
      motionPreset="scale"
      isCentered
      onClose={onClose}
      size="full"
      scrollBehavior="inside"
      isOpen={isOpen}
    >
      <ModalOverlay />
      <ModalContent zIndex={48} borderRadius="none" bg="rgba(0,0,0,.7)">
        <ModalCloseButton color="white" mt={isMobileOrTablet ? 8 : 0} size="lg" zIndex={48} />
        <ModalBody px={0}>
          <Center height="calc(100vh - 1rem)" width="100%">
            <Swiper
              slidesPerView={1}
              autoHeight
              initialSlide={initialSlide}
              spaceBetween={10}
              navigation={true}
              thumbs={{ swiper: thumbsSwiper }}
              className="slideShowModal"
            >
              {property?.photos?.map((photo) => (
                <SwiperSlide key={photo?.id}>
                  <Skeleton
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    isLoaded={!loading}
                  >
                    <Image
                      flex={1}
                      objectFit="contain"
                      alt="nsoko property, property image"
                      maxH="100%"
                      fallbackSrc={photo?.formats?.thumbnail?.url}
                      src={photo?.url}
                    />
                  </Skeleton>
                </SwiperSlide>
              ))}
            </Swiper>
          </Center>
          <Image
            src={images.logo_white}
            alt="nsoko property logo"
            width={62}
            opacity={0.5}
            m={4}
            position="absolute"
            bottom={0}
            left={0}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default SlideShowModal
